import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "sticky top-0 z-50 px-2 pt-4 pb-4 bg-white shadow-sm md:px-8" }
const _hoisted_3 = { class: "flex items-center w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "save_alt", -1)
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      footerBorder: true,
      fullHeight: true,
      fullWidth: true,
      noPadding: true,
      onYes: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hide'))),
      confirmOnly: true,
      showDialog: _ctx.show
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SegmentedControls, {
              options: _ctx.instancesAsSelectableOptions,
              modelValue: _ctx.currentInstance,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentInstance) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Btn, {
                tooltip: _ctx.$t('misc.download'),
                variant: 'icon',
                outline: true,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPrint())),
                class: "ml-auto mr-5 -mb-20",
                loading: _ctx.saving
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["tooltip", "loading"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instances, (_, instanceIndex) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "px-8",
                key: 'instance-' + instanceIndex,
                id: 'printable-preview-' + instanceIndex
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instances[instanceIndex], (__, slotIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "my-12",
                    style: {"break-inside":"avoid-page"},
                    key: 'instance-' + instanceIndex + '-slot-' + slotIndex
                  }, [
                    _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("event_participation_page.exercise")) + " " + _toDisplayString(slotIndex + 1), 1),
                    _createVNode(_component_AbstractEventParticipationSlot, {
                      "allow-edit-assessment": false,
                      "allow-edit-submission": false,
                      modelValue: _ctx.instancesAsSlotArrays[instanceIndex][slotIndex]
                    }, null, 8, ["modelValue"])
                  ]))
                }), 128))
              ], 8, _hoisted_5)), [
                [_vShow, instanceIndex === _ctx.currentInstance]
              ])
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}